var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99577 13.3507C9.63239 13.3507 9.32817 13.045 9.32817 12.6883V3.13358L9.37887 1.85977L8.80423 2.46271L7.52817 3.83843C7.40986 3.9743 7.22394 4.04224 7.06338 4.04224C6.70845 4.04224 6.45493 3.78748 6.45493 3.4393C6.45493 3.26097 6.52254 3.12509 6.6493 2.99771L9.50563 0.229287C9.6831 0.0594447 9.82676 0 9.99577 0C10.1732 0 10.3169 0.0594447 10.4859 0.229287L13.3423 2.99771C13.469 3.12509 13.5451 3.26097 13.5451 3.4393C13.5451 3.78748 13.2746 4.04224 12.9282 4.04224C12.7592 4.04224 12.5901 3.9743 12.4718 3.83843L11.1873 2.46271L10.6211 1.85977L10.6718 3.13358V12.6883C10.6718 13.045 10.3592 13.3507 9.99577 13.3507ZM5.15352 20C3.38732 20 2.5 19.1168 2.5 17.3674V8.89233C2.5 7.14296 3.38732 6.25978 5.15352 6.25978H7.51127V7.62701H5.17042C4.32535 7.62701 3.86056 8.08559 3.86056 8.96876V17.291C3.86056 18.1742 4.32535 18.6328 5.17042 18.6328H14.8211C15.6577 18.6328 16.1394 18.1742 16.1394 17.291V8.96876C16.1394 8.08559 15.6577 7.62701 14.8211 7.62701H12.4887V6.25978H14.8465C16.6127 6.25978 17.5 7.14296 17.5 8.89233V17.3674C17.5 19.1168 16.6127 20 14.8465 20H5.15352Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.54375e608b0ec05322312f13132cb345.svg";
export { ForwardRef as ReactComponent };